import {
	Calendar,
	Mail,
	MapPin,
	Navigation,
	Phone,
	PhoneCall,
	Send,
	User,
} from "lucide-react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { ProfileAccountRowConfig } from "web_myplann/Profile/Types/ProfileAccountRowConfig";
import {
	handleEmailClick,
	handlePhoneClick,
} from "web_myplann/Shared/Utils/openExternalApps";
import { getMapsLink } from "web_myplann/Utils/getMapsLink";

const R = Resources.Profile;

export const PROFILE_ACCOUNT_ROWS: ReadonlyArray<ProfileAccountRowConfig> = [
	{ field: "name", icon: User, label: R.Overview.name },
	{
		field: "email",
		icon: Mail,
		label: R.Fields.email,
		actionIcon: Send,
		onAction: handleEmailClick,
	},
	{
		field: "phone",
		icon: Phone,
		label: R.Fields.phone,
		actionIcon: PhoneCall,
		onAction: handlePhoneClick,
	},
	{
		field: "address",
		icon: MapPin,
		label: R.Overview.address,
		actionIcon: Navigation,
		onAction: (address) => window.open(getMapsLink(address), "_blank"),
	},
	{ field: "birthDate", icon: Calendar, label: R.Overview.birthDate },
];
